import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

const PDFViewer = ({ pdfUrl, show, onHide }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  // Limpar URL e garantir que estamos usando https
  let cleanUrl = pdfUrl || '';
  if (cleanUrl.endsWith('/')) {
    cleanUrl = cleanUrl.slice(0, -1);
  }
  if (cleanUrl.startsWith('http://')) {
    cleanUrl = cleanUrl.replace('http://', 'https://');
  }
  
  // Para contornar problemas de redirecionamento, vamos usar uma técnica
  // que adiciona um parâmetro de consulta único para evitar cache/redireção
  const uniqueUrl = `${cleanUrl}?v=${new Date().getTime()}`;
  
  // Handlers para iframe
  const handleIframeLoad = () => {
    console.log("iframe carregado com sucesso");
    setLoading(false);
  };
  
  const handleIframeError = () => {
    console.error("Erro ao carregar iframe");
    setError(true);
    setLoading(false);
  };

  // Se o navegador não suportar o evento onerror em iframes
  setTimeout(() => {
    if (loading) {
      console.log("Timeout do carregamento do iframe - considerando como carregado");
      setLoading(false);
    }
  }, 5000);
  
  // Outra abordagem: usar objeto ou embed
  const renderPdfWithEmbed = () => (
    <embed 
      src={uniqueUrl} 
      type="application/pdf" 
      width="100%" 
      height="100%" 
      style={{ border: "none" }} 
    />
  );
  
  const renderPdfWithObject = () => (
    <object 
      data={uniqueUrl} 
      type="application/pdf" 
      width="100%" 
      height="100%" 
      style={{ border: "none" }} 
    >
      <p>Seu navegador não suporta a visualização de PDFs. 
        <a href={uniqueUrl} target="_blank" rel="noopener noreferrer">
          Clique aqui para baixar o PDF
        </a>
      </p>
    </object>
  );

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Visualizador de PDF</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '70vh', padding: 0 }}>
        {loading && (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Carregando...</span>
            </Spinner>
          </div>
        )}
        
        {error ? (
          <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <div className="alert alert-warning">
              <p>Não foi possível carregar o PDF no visualizador embutido.</p>
              <Button 
                variant="primary" 
                onClick={() => window.open(cleanUrl, '_blank')}
                className="mt-3"
              >
                Abrir PDF em Nova Guia
              </Button>
            </div>
            
            {/* Tentar visualizar com object como fallback */}
            <div className="mt-4 w-100 h-75">
              {renderPdfWithObject()}
            </div>
          </div>
        ) : (
          <div style={{ height: '100%', display: loading ? 'none' : 'block' }}>
            {/* Tentar as duas abordagens */}
            <div style={{ display: 'none' }}>
              <iframe
                src={uniqueUrl}
                title="Visualizador de PDF"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                onLoad={handleIframeLoad}
                onError={handleIframeError}
              />
            </div>
            
            {/* Usar object como método principal */}
            {renderPdfWithObject()}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PDFViewer;